'use client';
import { Badge as Badge$1 } from './badge.js';
import { BadgePosition } from './badge-position.js';

/**
 * `Badge` is a non-interactive component for displaying status with or without numbers.
 *
 * @example without children
 * <Badge count={5} maxCount={10} />
 */
const Badge = Object.assign(Badge$1, { Position: BadgePosition });
Badge.Position.displayName = 'Badge.Position';

export { Badge, BadgePosition };
